import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=7915f120&scoped=true&"
import script from "./Searchbar.vue?vue&type=script&lang=js&"
export * from "./Searchbar.vue?vue&type=script&lang=js&"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=7915f120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7915f120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
